module.exports = __webpack_public_path__ + "static/img/アセット 78@3x.b628fb9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/アセット 78@3x.png
// module id = 4PFE
// module chunks = 1